import { Link, NavLink } from "react-router-dom";
import { ReactComponent as Down }from "../../../assets/images/down.svg"
import { useEffect, useState } from "react";
import { getCategories } from "../../../services/algolia";
import { getCategoryPage } from "../../../utils/utils";
import { getCategoryForPalettes } from "../../../services/algoliaPaletteService";

interface NavLink {
    title: string
    href: string
    categoryCode?: string
}

export default function Nav() {

    const [mobileMenuVisibility, setMobileMenuVisibility] = useState(false);
    const [navLinks, setNavLinks] = useState<NavLink[]>([]);

    useEffect(() => {

        const titleToLink: NavLink[] = [
            {
                title: window.steelcase_i18n['steelcase-finish-library'].nav.overview_upholstery ? window.steelcase_i18n['steelcase-finish-library'].nav.overview_upholstery : "Overview",
                href: "/finishlibrary",
            },
            {
                title:'Fabric',
                href: "/finishes/fabric",
                categoryCode: getCategoryPage('fabric')
            },
            {
                title: "Laminate & Wood",
                href: "/finishes/laminate-wood",
                categoryCode: getCategoryPage('laminate_wood')
            },
            {
                title: "Paint",
                href: "/finishes/paint",
                categoryCode: getCategoryPage('paint')
            },
            {
                title: "More Surfaces",
                href: "/finishes/more-surfaces",
                categoryCode: getCategoryPage('more_surfaces')
            },
            {
                title: "Palettes",
                href: "/palettes",
                categoryCode: getCategoryPage('palettes')
            },
            {
                title: "COM",
                href: "/customer-materials",
            } 
        ]

        const getCategoryLabel = async () => {
            
            const updatedLinks = await Promise.all(titleToLink.map(async (item) => {
                if(item.categoryCode) {
                    if(item.title === "Palettes") {
                        const data = await getCategoryForPalettes(item.categoryCode);
                        
                        if(data && data['category.label']) {
                            const [key] = Object.entries(data['category.label'])
                            item.title = key[0]
                        }
                    } else {
                        const data = await getCategories(item.categoryCode);
                       
                        if(data && data['category.label']) {
                            const [key] = Object.entries(data['category.label'])
                            item.title = key[0];
                        }
                    }
                }
                return item;
            }))
            setNavLinks(updatedLinks)
        }
        
        getCategoryLabel();
        
    }, [])

    return (
        <div className={"finish-nav finish-nav__sticky"}>
            <div className={"finish-nav__container finish-nav__container--flex"}>
                    <div className={"finish-nav__menu"}>
                        <div className={"finish-nav__menu-heading"}>
                            <Link to={"/finishlibrary"}><h1>Finish Library</h1></Link>
                        </div>

                        <div className={"finish-nav__menu-heading--mobile"}>
                            <button onClick={() => setMobileMenuVisibility(!mobileMenuVisibility)}><h1>Finish Library <Down /></h1></button>
                        </div>
                        
                        <div className={`finish-nav__menu-items ${mobileMenuVisibility ? "finish-nav__menu-items--visible" : ""}`}>
                            {
                                navLinks.map((link) => {

                                    if(link.title === "COM" && window.steelcase_finish_library.siteUrl.path !== "/") {
                                        return null;
                                    }

                                    return (
                                        <NavLink
                                            key={link.href}
                                            to={link.href} 
                                            className={({isActive}) => isActive ? "finish-nav__menu-item--active" : ""}
                                            onClick={() => mobileMenuVisibility && setMobileMenuVisibility(false)}
                                            children={<span className={"finish-nav__menu-item"}>{link.title}</span>}
                                        />
                                    )
                                })
                            }
                        </div>
                        
                    </div>
            </div>
        </div>
    )
}